import { _ } from "../core/polyglot/polyglot.js";
import Account from "./Account.js";

/**
 * `undefinedAccount` is an account that's not defined in the
 * current context. An account number may still be passed to
 * the constructor.
 */
export default class UndefinedAccount extends Account {
	getName() {
		return _("Undefined account");
	}
}
